<div class="d-f jc-sb ai-c mb-xxs">
	<app-tab
		[tabs]="usersTabs"
		[navTab]="navTab"
		(action)="onTabClick($event)"
	></app-tab>
	<button mat-flat-button color="primary" class="no-mob" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo usuário</span>
	</button>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<div class="d-f jc-fs" *ngIf="!loading && !users.length">
	<p class="fs-xs lh-xs fs-i gray">
		Nenhum usuário {{ activeUsers ? 'ativo' : 'inativo' }} cadastrado
	</p>
</div>
<ng-container *ngIf="!loading && users.length">
	<div
		class="pos-r mb-xxxs pb-nano br-md c-p card"
		*ngFor="let user of users; let index = index"
		(click)="onEditUser(user.id)"
	>
		<div class="d-f ai-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f fd-c jc-c col">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Usuário</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">{{ user.name }}</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Data da criação</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">
					{{ user.created_at | date: 'dd/MM/YYYY' }}
				</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Empresa</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">
					{{ user.org_name }}
				</span>
			</div>
			<div class="d-f fd-c jc-c col no-tab no-mob">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Telefone</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">
					{{ user.phone | mask: phoneMask(user.phone) }}
				</span>
			</div>
			<div class="d-f fd-c jc-c chip {{ user.active ? '' : 'red' }}">
				<span class="fs-xs lh-sm">{{ user.active ? 'Ativo' : 'Inativo' }}</span>
			</div>
		</div>
	</div>
	<div class="pb-huge">&nbsp;</div>
</ng-container>
